module.exports = __webpack_public_path__ + "img/slide3.ac4d6f01.png";